<div class="modal-header">
    <div class="row w-100">
        <div class="col-md-11">
            <h5 class="modal-title">Schedule A Meeting</h5>
        </div>
        <div class="col-md-1 pe-0">
            <button type="button" class="close float-end text-white pe-0" aria-label="Close"
                data-testid="modals.schedule-meeting.close-btn" (click)="closeModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</div>

<div class="modal-body">
    <form [formGroup]="scheduleMeetingForm" novalidate>
        <div class="form-group col-md-12 col-sm-12 col-xs-12">
            <h4 class="font-18">If you wish to schedule a meeting with {{advisorFullName}}, please complete the
                information below. <span class="capitalize">{{advisorFirstName}}</span> will contact you to confirm the
                appointment.</h4>
            <!-- <div class="col-md-12 col-sm-12 ps-0 pe-0">
                <select class="form-control" [(ngModel)]="contact_advisor" formControlName="contactAdvisor">
                    <option value='' selected>Select Recipient</option>
                    <option *ngFor="let option of advisoryTeam" value="{{option.id}}">{{option.name}} -
                        {{option.user_type}} </option>
                </select>
            </div> -->
        </div>
        <div class="form-group col-md-12 col-sm-12 col-xs-12">
            <div class="col-md-12 col-sm-12 ps-0 pe-0 pb-4">
                <input class="form-control contact-us-com" [(ngModel)]="meeting_subject" type="text"
                    name="meetingSubject" formControlName="meetingSubject" placeholder="Subject" autofocus="true"
                    aria-label="Meeting subject"
                    data-testid="modals.schedule-meeting.subject-input" />
                    <div *ngIf="scheduleMeetingFormSubmitted" class="text-danger pt-1" role="alert">
                        <div *ngIf="formControl.meetingSubject.errors?.required">Subject is mandatory.</div>
                    </div>
            </div>
        </div>

        <div class="form-group col-md-12 col-sm-12 col-xs-12">
            <div class="col-md-12 col-sm-12 ps-0 pe-0 pb-4">
                <textarea class="form-control contact-us-bordernone" rows=6 columns=12 type="text" name="meetingMessage"
                    placeholder="Type your message here. Please include the best way to be contacted." autofocus="true"
                    [(ngModel)]="meeting_message" formControlName="meetingMessage"
                    aria-label="Meeting message"
                    data-testid="modals.schedule-meeting.message-textarea">
                </textarea>
                <div *ngIf="scheduleMeetingFormSubmitted" class="text-danger pt-1" role="alert">
                    <div *ngIf="formControl.meetingMessage.errors?.required">Message is mandatory.</div>
                </div>
            </div>

        </div>

        <div class="form-group col-md-12 col-sm-12 col-xs-12 row pe-0">
            <div class="col-md-4 col-sm-4 col-xs-12 meetingGroup pb-4 pe-0">
                <label for="meetingDateInput">Suggested Meeting Time</label>
                <p class="input-group mb-0">
                    <input type="text" id="meetingDateInput" placeholder="MM/DD/YYYY" class="form-control" #dp="bsDatepicker" bsDatepicker
                        [required]="true" [bsConfig]="bsConfig" formControlName="meetingDate" [(ngModel)]="meeting_date"
                        [minDate]="minDate" [maxDate]="maxDate" (blur)="setMaxDate()"
                        aria-label="Meeting date"
                        data-testid="modals.schedule-meeting.date-input" />
                    <span class="cal-icon" aria-label="Open date picker" role="button" (click)="dp.toggle()"><i class="fa fa-calendar"
                            aria-hidden="true"></i></span>
                </p>
                <div *ngIf="scheduleMeetingFormSubmitted" class="text-danger pt-1" role="alert">
                    <div *ngIf="formControl.meetingDate.errors?.required">Meeting date is mandatory.</div>
                </div>
            </div>

            <div class="col-md-3 col-sm-4 col-xs-12  pe-0 ps-0">
                <timepicker *ngIf="eventList.length <= 0" name="meetingTime1" formControlName="meetingTime1"
                    [(ngModel)]="time" required></timepicker>
                <div *ngIf="eventList.length > 0" class="meetingDate ps-0 pe-0">
                    <select [(ngModel)]="meeting_time" class="selectTimezonelist" name="meetingTime"
                        formControlName="meetingTime" required
                        aria-label="Meeting time"
                        data-testid="modals.schedule-meeting.time-select">
                        <option value="" selected>Select Time</option>
                        <option *ngFor="let eventTime of eventList" value="{{eventTime[0]}}">{{eventTime[0]}} -
                            {{eventTime[1]}}</option>
                    </select>
                </div>
                <div *ngIf="scheduleMeetingFormSubmitted" class="text-danger pt-1" role="alert">
                    <div *ngIf="formControl.meetingTime.errors?.required">Meeting time is mandatory.</div>
                </div>
            </div>

            <div class="col-md-4 col-sm-4 col-xs-12 meetingZone pe-0 padding-top-30">
                <select class="form-control" [(ngModel)]="selectedTimeZone" formControlName="meetingTimezone"
                    aria-label="Meeting timezone"
                    data-testid="modals.schedule-meeting.timezone-select">
                    <option [ngValue]="undefined" selected>Select Timezone</option>
                    <option value="Eastern Standard Time">Eastern Standard Time</option>
                    <option value="Central Standard Time">Central Standard Time</option>
                    <option value="Mountain Standard Time">Mountain Standard Time</option>
                    <option value="Pacific Standard Time">Pacific Standard Time</option>
                </select>
                <div *ngIf="scheduleMeetingFormSubmitted" class="text-danger pt-1" role="alert">
                    <div *ngIf="formControl.meetingTimezone.errors?.required">Timezone is mandatory.</div>
                </div>
            </div>

        </div>

    </form>
</div>
<div class="clear"> </div>

<div class="modal-footer">
    <button type="button" class="btn btn-link" data-testid="modals.schedule-meeting.cancel-btn" (click)="closeModal()">
        CANCEL
    </button>
    <button type="button" class="btn btn-primary btn-sm rounded-pill" data-testid="modals.schedule-meeting.submit-btn" (click)="scheduleMeeting()" [formvalid]="scheduleMeetingForm.valid" appButtonDisable>
        Schedule Meeting
    </button>
</div>
